import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import CurdTokenervice from '../../services/axios/CurdTokenervice'
import { setMessage } from './message'

export const getstudentMarks = createAsyncThunk('stdMark/getstdMark', async (arg, thunkAPI) => {
    const { rejectWithValue } = thunkAPI
    const { token, stdId, testKindId } = arg
    try {
        const res = await CurdTokenervice.getDegree(token, "mark", stdId, testKindId);
        thunkAPI.dispatch(setMessage(res.data.message))
        return res.data
    } catch (error) {
        if (error.response?.status === 404) {
            return []
        }
        const message = error.message
        thunkAPI.dispatch(setMessage(message))
        return rejectWithValue(error.message)
    }
})

const studentMarkSlice = createSlice({
    name: 'stdMark',
    initialState: { isloading: false, marks: [], message: '' },
    reducers: {
        delMarksMessage: (state, action) => {
            state.message = ''
        }
    },
    extraReducers: (builder) => {
        builder
            // Get stutent Marks
            .addCase(getstudentMarks.pending, (state) => {
                state.isloading = true
                state.message = ''
            })
            .addCase(getstudentMarks.fulfilled, (state, action) => {
                state.isloading = false;
                state.marks = action.payload;
                state.message = ''
            })
            .addCase(getstudentMarks.rejected, (state, action) => {
                state.isloading = false
                state.message = action.payload
            })
    },
})


export const { delMarksMessage } = studentMarkSlice.actions
export default studentMarkSlice.reducer